import { Modal } from 'antd';
import type { ReactNode } from 'react';

/**
 * Thin wrapper over Ant Modal for record edit dialogs. Callers render their own
 * footer (so submit buttons can live inside a <form>); pass `footer` for the common case.
 */
export function Dialog({ open, title, onClose, children, footer, width }: {
  open: boolean;
  title: ReactNode;
  onClose: () => void;
  children: ReactNode;
  footer?: ReactNode;
  width?: number;
}) {
  return (
    <Modal open={open} title={title} onCancel={onClose} footer={null} width={width} destroyOnHidden mask={{ closable: false }}>
      {children}
      {footer ? <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 16 }}>{footer}</div> : null}
    </Modal>
  );
}
